<page-loader *ngIf="isLoaded !== 3"></page-loader>
<div id="page-organization-listing" class="page-section series-form-page" *ngIf="isLoaded == 3">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/app']">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item app-l-current-page">
                    Organizations
                </li>
            </ul>
        </div>
    </div>

    <div class="page-section-content">
        <my-tabs>
            <!-- Active Organizations Tab -->
            <my-tab [tabTitle]="'Active Organizations'">
                <div class="tab-header">
                    <button class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doCreate()">
                        <svg-icon icon="plus" class="btn-icon"></svg-icon> Create Organization
                    </button>
                    <button class="app-c-btn app-c-btn--secondary app-c-btn--curve" (click)="exportListingCsv()"
                        [disabled]="isExporting">
                        {{ isExporting ? 'Preparing…' : 'Export Listing' }}
                    </button>
                    <button class="app-c-btn app-c-btn--secondary app-c-btn--curve" (click)="exportResourcesCsv()"
                        [disabled]="isExporting">
                        {{ isExporting ? 'Preparing…' : 'Export Resources' }}
                    </button>
                    <button class="app-c-btn app-c-btn--secondary app-c-btn--curve" (click)="doClone()">
                        Clone Organization
                    </button>
                </div>
                <div class="table-responsive">
                    <table class="table user-table">
                        <thead>
                            <tr>
                                <th translate>organizationListing.headers.0</th>
                                <th translate>organizationListing.headers.1</th>
                                <th translate>organizationListing.headers.2</th>
                                <th translate>organizationListing.headers.4</th>
                                <th class="actions-col"></th>
                            </tr>
                            <tr class="filter-row">
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="cols[0]" (input)="valueChange(0)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="cols[1]" (input)="valueChange(1)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="cols[2]" (input)="valueChange(2)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="cols[3]" (input)="valueChange(3)" />
                                </th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let organization of activeorganizations">
                                <tr [ngClass]="{'highlighted': organization.isPaired, 'alert-row': (organization.hasAlerts && organization.parentOrgId === null)}">
                                    <td class="strong">
                                        <a tabindex="0" class="org-link" [routerLink]="['/admin/organization', organization.id]">
                                            {{organization.name}}</a>
                                        <div class="org-relation" *ngIf="organization.parentOrganization">
                                            <span class="relation-label">Parent:</span>
                                            <a class="org-link"
                                                [routerLink]="['/admin/organization', organization.parentOrganization.id]">{{organization.parentOrganization.name}}</a>
                                        </div>
                                        <div class="org-relation" *ngIf="organization.childOrganizations">
                                            <span class="relation-label">Children:</span>
                                            <span *ngFor="let child of organization.childOrganizations; let last = last">
                                                <a tabindex="0" class="org-link"
                                                    [routerLink]="['/admin/organization', child.id]">{{child.name}}</a><span *ngIf="!last">, </span>
                                            </span>
                                        </div>
                                    </td>
                                    <td>{{organization.subdomain}}</td>
                                    <td class="allowed-domains">{{organization.allowedDomains}}</td>
                                    <td>{{organization?.crmGroup?.assigned_user_name}}</td>
                                    <td class="actions-col">
                                        <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                            [routerLink]="['/admin/organization', organization.id]" title="View">
                                            <svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
                                        </button>
                                        <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                            (click)="onEdit(organization.id)" title="Edit">
                                            <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                        </button>
                                        <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                            (click)="onActivate(organization.id, false)" title="Deactivate">
                                            <svg-icon icon="lock-circle" class="w-100 h-100"></svg-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr class="alert-last-row" *ngIf="organization.hasAlerts">
                                    <td colspan="5">
                                        This organization is inactive in Sugar but active here. Organization
                                        should be disabled in Boost.
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <p *ngIf="!activeorganizations || activeorganizations.length === 0" class="empty-state">
                        No active organizations found.
                    </p>
                </div>
            </my-tab>

            <!-- Disabled Organizations Tab -->
            <my-tab [tabTitle]="'Disabled Organizations'">
                <div class="table-responsive">
                    <table class="table user-table">
                        <thead>
                            <tr>
                                <th translate>organizationListing.headers.0</th>
                                <th translate>organizationListing.headers.1</th>
                                <th translate>organizationListing.headers.2</th>
                                <th translate>organizationListing.headers.4</th>
                                <th class="actions-col"></th>
                            </tr>
                            <tr class="filter-row">
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="disCols[0]" (input)="disabledValueChange(0)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="disCols[1]" (input)="disabledValueChange(1)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="disCols[2]" (input)="disabledValueChange(2)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="disCols[3]" (input)="disabledValueChange(3)" />
                                </th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let organization of disabledOrganizations"
                                [ngClass]="{'highlighted': organization.isPaired}">
                                <td class="strong">
                                    <a tabindex="0" class="org-link" [routerLink]="['/admin/organization', organization.id]">
                                        {{organization.name}}</a>
                                    <div class="org-relation" *ngIf="organization.parentOrganization">
                                        <span class="relation-label">Parent:</span>
                                        <a class="org-link"
                                            [routerLink]="['/admin/organization', organization.parentOrganization.id]">{{organization.parentOrganization.name}}</a>
                                    </div>
                                    <div class="org-relation" *ngIf="organization.childOrganizations">
                                        <span class="relation-label">Children:</span>
                                        <span *ngFor="let child of organization.childOrganizations; let last = last">
                                            <a tabindex="0" class="org-link"
                                                [routerLink]="['/admin/organization', child.id]">{{child.name}}</a><span *ngIf="!last">, </span>
                                        </span>
                                    </div>
                                </td>
                                <td>{{organization.subdomain}}</td>
                                <td class="allowed-domains">{{organization.allowedDomains}}</td>
                                <td>{{organization?.crmGroup?.assigned_user_name}}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        [routerLink]="['/admin/organization', organization.id]" title="View">
                                        <svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onEdit(organization.id)" title="Edit">
                                        <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onActivate(organization.id)" title="Activate">
                                        <svg-icon icon="unlock-circle" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="!disabledOrganizations || disabledOrganizations.length === 0" class="empty-state">
                        No disabled organizations found.
                    </p>
                </div>
            </my-tab>

            <!-- Demo Accounts Tab -->
            <my-tab [tabTitle]="'Demo Accounts'">
                <div class="table-responsive">
                    <table class="table user-table">
                        <thead>
                            <tr>
                                <th translate>organizationListing.headers.0</th>
                                <th translate>organizationListing.headers.1</th>
                                <th translate>organizationListing.headers.2</th>
                                <th translate>organizationListing.headers.4</th>
                                <th class="actions-col"></th>
                            </tr>
                            <tr class="filter-row">
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="demoCols[0]" (input)="demoValueChange(0)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="demoCols[1]" (input)="demoValueChange(1)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="demoCols[2]" (input)="demoValueChange(2)" />
                                </th>
                                <th>
                                    <input class="filter-control" type="text" placeholder="Filter..."
                                        [(ngModel)]="demoCols[3]" (input)="demoValueChange(3)" />
                                </th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let organization of demoOrganizations">
                                <td class="strong">
                                    <a tabindex="0" class="org-link" [routerLink]="['/admin/organization', organization.id]">
                                        {{organization.name}}</a>
                                </td>
                                <td>{{organization.subdomain}}</td>
                                <td class="allowed-domains">{{organization.allowedDomains}}</td>
                                <td>{{organization?.crmGroup?.assigned_user_name}}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        [routerLink]="['/admin/organization', organization.id]" title="View">
                                        <svg-icon icon="eye-icon" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onEdit(organization.id)" title="Edit">
                                        <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="!demoOrganizations || demoOrganizations.length === 0" class="empty-state">
                        No demo accounts found.
                    </p>
                </div>
            </my-tab>

            <!-- Organization Resources Tab -->
            <my-tab [tabTitle]="'Organization Resources'">
                <div class="table-responsive">
                    <table class="table user-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of organizationResources">
                                <td class="strong">{{row.Name}}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onEdit(row.ID)" title="Edit">
                                        <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="!organizationResources || organizationResources.length === 0" class="empty-state">
                        No organization resources found.
                    </p>
                </div>
            </my-tab>

            <!-- Single Sign-On Integrations Tab -->
            <my-tab [tabTitle]="'Single Sign-On Integrations'">
                <div class="table-responsive">
                    <table class="table user-table sso-table">
                        <thead>
                            <tr>
                                <th class="sso-name-col">Name</th>
                                <th>IDP Entity ID</th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of organizationsAuth">
                                <td class="strong sso-name-col">{{row.Name}}</td>
                                <td>{{row.Idp_entity_id}}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onEditAuth(row.ID)" title="Edit">
                                        <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="!organizationsAuth || organizationsAuth.length === 0" class="empty-state">
                        No SSO integrations found.
                    </p>
                </div>
            </my-tab>
        </my-tabs>
    </div>
</div>
